// @ts-ignore
import './library'
import './styles/global.scss'
import './styles/redesign.scss'

import { AppRoutes } from './router/AppRoutes'
import DayJS from 'dayjs'

import { Suspense } from 'react'
import { ThemeProvider } from 'styled-components'
import { defaultTheme } from './styles/themes/defaultTheme'
import duration from 'dayjs/plugin/duration'
import relativeTime from 'dayjs/plugin/relativeTime'
import { LoadingBolt } from './components/LoadingBolt'
import { ShareProvider } from './context/ShareContext'

DayJS.extend(relativeTime)
DayJS.extend(duration)

const App = () => {
    return (
        <ShareProvider>
            <Suspense fallback={<LoadingBolt />}>
                <ThemeProvider theme={defaultTheme}>
                    <AppRoutes />
                </ThemeProvider>
            </Suspense>
        </ShareProvider>
    )
}

export default App
